import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";


@Options({
    template: false,
    el: ".js-nav-primary-wrap",
    ui: {
        mainNavCollapseToggleLinks: ".nav-item > a[data-toggle='collapse']",
        mainNavAccordionDrawers: ".js-subnav-wrap.collapse",
        subnavCloseBtns: ".js-btn-subnav-close-x"
    }
})

export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // -------------------------------------
    // CONSTANTS
    // -------------------------------------

    // * match value in `config.scss`
    static readonly BREAKPOINT_NAV_SWAP = 1200;

    // -------------------------------------
    // EVENTS
    // -------------------------------------

    /** 
     * if desktop width, when a main nav item that controls
     * an accordion is clicked, close all other drawers 
     */
    @on("click @ui.mainNavCollapseToggleLinks")
    onClickCollapseToggleLink(JQueryEventObject) {
        if (!this.isMobileNav()) {
            const $thisTogglelink = $(JQueryEventObject.currentTarget);
            const targetDrawerID = $thisTogglelink.attr("href");

            this.closeAllDrawers();
            this.openActiveDrawer(targetDrawerID); // just a backup: doesn't seem to need this due to default behavior
        }
    }

    /** 
     * on desktop only: 
     * ensure that clicking on subnav drawers does
     * NOT close them by excluding them from window click
     */
    @on("click @ui.mainNavAccordionDrawers")
    onClickAccordionDrawers(JQueryEventObject) {
        if (!this.isMobileNav()) {
            JQueryEventObject.stopPropagation();
        }
    }

    @on("click @ui.subnavCloseBtns")
    onClickSubnavCloseBtn(JQueryEventObject) {
        this.closeAllDrawers();
    }

    // -------------------------------------
    // METHODS
    // -------------------------------------

    onRender() {
        console.log("nav desktop drawer controls viewcontroller rendered");
        this.initWindowCheck();
        this.windowResizeCheck();
        this.addClickOffNavHandler();
    }

    /** 
     * on desktop only: 
     * close all drawers
     */
    closeAllDrawers() {
        if (!this.isMobileNav()) {
            this.ui.mainNavAccordionDrawers.collapse("hide"); // bootstrap function to close all drawers
        }
    }

    /** 
     * close subnav drawers when clicking anywhere on window,
     * EXCEPT if clicking on the subnav drawers.
     */
    addClickOffNavHandler() {
        // ** ALL OF THE FOLLOWING WORK:
        // window.addEventListener("click", () => {this.closeAllDrawers()});
        // $(window).click(() => this.closeAllDrawers());
        $(window).on("click", () => this.closeAllDrawers());
    }

    /** 
     * opens the active drawer.
     */
    openActiveDrawer(targetDrawerID: string) {
        const $el = $(this.el);
        const $activeDrawer = this.$el.find(targetDrawerID);

        (<any>$activeDrawer).collapse("show"); // need to cast as type <any> to prevent error here:
    }

    /** 
     * tests to see if window is smaller than width
     * for mobile nav.
     */
    isMobileNav() {
        // need to reach out to window here.
        if ($(window).width() <= ViewController.BREAKPOINT_NAV_SWAP) {
            return true;
        } else {
            return false;
        }
    }

    /** 
     * recurring check when window resized.
     */
    windowResizeCheck() {
        $(window).resize(() => {
            this.oneTimeWindowCheck();

            if (this.isMobileNav) {
                // stub
            }
        });
    }

    /** 
     * initially check to see if viewport width is within
     * mobile breakpoint.
     */
    initWindowCheck() {
        this.oneTimeWindowCheck();
    }

    /** 
     * initially check to see if viewport width is within
     * mobile breakpoint.
     */
    oneTimeWindowCheck() {
        if (this.isMobileNav()) {
            // this.activateAccordions();
            // console.log("i'm at a mobile breakpoint");
        } else {
            // this.deactivateAccordions();
            // console.log("i'm at a desktop breakpoint");
        }
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/nav-desktop-drawer-controls/controller.ts